import * as THREE from 'three';
export const generateNewCanvas = () => {
    return {
        id: 'CANVAS',
        type: 'CANVAS',
        background: new THREE.Color(0x36363F),
        fog: null,
        fogColor: null,
        fogDensity: null,
        antialias: true,
        physicallyCorrectLights: false,
        shadows: true
    };
};
